import {
  ICICI_QUEUE_LOAD,
  ICICI_QUEUE_UPDATE,
  ICICI_QUEUE_ERROR,
  ICICI_DOCTOR_STATE_SET,
  ICICI_CALL_STARTED,
} from '../actions/iciciQueue';

const defaultState = {
  stats: {},
  queue: [],
  doctors: [],
  doctorStatus: null,   // current logged-in doctor's availability record
  assignedCase: null,   // case assigned to this doctor
  activeCall: null,     // call data after startCall (token, sessionId, etc.)
  error: null,
};

export default function iciciQueue(state = defaultState, action) {
  switch (action.type) {
    case ICICI_QUEUE_LOAD:
    case ICICI_QUEUE_UPDATE:
      return {
        ...state,
        stats: action.payload.stats || state.stats,
        queue: action.payload.queue || state.queue,
        doctors: action.payload.doctors || state.doctors,
        error: null,
      };

    case ICICI_DOCTOR_STATE_SET:
      return {
        ...state,
        doctorStatus: action.payload.doctorStatus || state.doctorStatus,
        assignedCase: action.payload.assignedCase,
        error: null,
      };

    case ICICI_CALL_STARTED:
      return {
        ...state,
        activeCall: action.payload,
        doctorStatus: { ...(state.doctorStatus || {}), status: 'IN_CALL' },
      };

    case ICICI_QUEUE_ERROR:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
